/* eslint-disable import/prefer-default-export */

// magic number
export const contentWidth = '404px';
